import * as React from "react";

import {PhosphorIcon} from "@khanacademy/wonder-blocks-icon";

import docIcon from "@phosphor-icons/core/regular/file-text.svg";

export const DocumentIcon = (): React.ReactElement => (
    <PhosphorIcon icon={docIcon} size="small" />
);
